import { useContext } from "react";
import { UserContext } from "../context/UserContext";

export const FEATURE_KEYS = {
    QUOTE_COMPARE: "quote-compare",
    VENDOR_DISCOVERY: "vendor-discovery",
    RFQS: "rfqs",
} as const;

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];

export function useFeatureAccess() {
    const { user } = useContext(UserContext);
    const disabledFeatures = user?.lastTeam?.disabledFeatures ?? [];

    const isFeatureEnabled = (featureKey: string) => !disabledFeatures.includes(featureKey);

    return { isFeatureEnabled, disabledFeatures };
}
